export class Constants {
    public static LOCAL_TOKEN = "wisper_token";
    // public static LOCAL_CURRENT_PARTNER_STORE = "cloov_current_partner_store";
}
